module.exports = __webpack_public_path__ + "media/marqeta_replacement/card-in-mail-e8d4d87e.png";